import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function DesktopIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9989 3.75L19.2726 3.95565C20.5578 3.99199 21.6208 4.96765 21.767 6.24505C22.0905 9.07266 22.0905 11.9279 21.767 14.7556C21.6208 16.033 20.5578 17.0086 19.2726 17.0449L13.249 17.2153V19.2503H16.999C17.4132 19.2503 17.749 19.5861 17.749 20.0003C17.749 20.4145 17.4132 20.7503 16.999 20.7503H6.99896C6.58475 20.7503 6.24896 20.4145 6.24896 20.0003C6.24896 19.5861 6.58475 19.2503 6.99896 19.2503H10.749V17.2153L4.72532 17.0449C3.4401 17.0086 2.37708 16.033 2.23093 14.7556C1.9074 11.9279 1.9074 9.07266 2.23093 6.24504C2.37708 4.96764 3.4401 3.99199 4.72532 3.95565L11.9989 3.75ZM4.99896 13.7503C4.58475 13.7503 4.24896 14.0861 4.24896 14.5003C4.24896 14.9145 4.58475 15.2503 4.99896 15.2503H18.999C19.4132 15.2503 19.749 14.9145 19.749 14.5003C19.749 14.0861 19.4132 13.7503 18.999 13.7503H4.99896Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
